import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCut, faPencilRuler, faShoePrints, faMagic, faCheckDouble, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import '../styles/Process.css';

function Process() {
  return (
    <div className="process-page">
      {/* Hero Section */}
      <section className="process-hero">
        <div className="process-hero-overlay"></div>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white py-5"
          >
            <h1 className="display-3 fw-bold mb-4">Üretim Sürecimiz</h1>
            <p className="lead mb-0">Her bir kılıfın arkasındaki ustalık ve özen</p>
          </motion.div>
        </Container>
      </section>

      {/* Detaylı Süreç */}
      <section className="py-5">
        <Container>
          <div className="timeline">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="timeline-item"
            >
              <div className="timeline-icon">
                <FontAwesomeIcon icon={faPencilRuler} />
              </div>
              <div className="timeline-content">
                <h3>1. Tasarım ve Planlama</h3>
                <p>İlk adım olarak, müşterilerimizin ihtiyaçlarını ve güncel trendleri analiz ediyoruz. Bu doğrultuda, farklı modeller, renkler ve desenler için tasarımlar oluşturuyoruz. 3D çizimler ve prototip tasarımları hazırlayarak üretim detaylarını planlıyoruz.</p>
                <img src="/images/process/design.jpg" alt="Tasarım süreci" className="timeline-image" />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="timeline-item"
            >
              <div className="timeline-icon">
                <FontAwesomeIcon icon={faCut} />
              </div>
              <div className="timeline-content right">
                <h3>2. Malzeme Seçimi</h3>
                <p>Tasarımlarımıza uygun malzemeleri özenle seçiyoruz. Silikon, TPU, deri ya da sert plastik gibi seçenekleri değerlendiriyor, dayanıklılık ve kalite testlerinden geçiriyoruz. Çevre dostu ve uzun ömürlü malzemeleri tercih ediyoruz.</p>
                <img src="/images/process/materials.jpg" alt="Malzeme hazırlığı" className="timeline-image" />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="timeline-item"
            >
              <div className="timeline-icon">
                <FontAwesomeIcon icon={faShoePrints} />
              </div>
              <div className="timeline-content">
                <h3>3. Kalıp ve Prototip Üretimi</h3>
                <p>Telefon kılıfı tasarımlarımız için üretim kalıplarını hazırlıyoruz. Kalıplarımız tamamlandıktan sonra ilk prototipleri üretiyor ve kalite kontrol testlerinden geçiriyoruz. Bu aşamada, tasarımlarımızı mükemmelleştirmek için gerekli düzenlemeleri yapıyoruz.</p>
                <img src="/images/process/leather-work.jpg" alt="Deri işleme" className="timeline-image" />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="timeline-item"
            >
              <div className="timeline-icon">
                <FontAwesomeIcon icon={faMagic} />
              </div>
              <div className="timeline-content right">
                <h3>4. Seri Üretim</h3>
                <p>Onaylanan prototiplerimizi esas alarak seri üretime başlıyoruz. Üretim sürecinde, yüksek teknoloji makinelerle kılıflarımızı hatasız bir şekilde üretiyoruz. Her bir ürünün standartlara uygun olmasını sağlamak için sürekli kontrol yapıyoruz.</p>
                <img src="/images/process/stitching.jpg" alt="Dikiş süreci" className="timeline-image" />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="timeline-item"
            >
              <div className="timeline-icon">
                <FontAwesomeIcon icon={faCheckDouble} />
              </div>
              <div className="timeline-content">
                <h3>5.  Baskı ve Özelleştirme</h3>
                <p>Kılıflarımızı, desenler, logolar veya kişisel tasarımlarla zenginleştiriyoruz. UV baskı, lazer kesim ve sıcak damga gibi yöntemlerle estetik dokunuşlar ekliyoruz. Müşterilerimizin taleplerine göre özel tasarımlar yaparak onların beklentilerini karşılıyoruz.</p>
                <img src="/images/process/quality.jpg" alt="Kalite kontrol" className="timeline-image" />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="timeline-item"
            >
              <div className="timeline-icon">
                <FontAwesomeIcon icon={faBoxOpen} />
              </div>
              <div className="timeline-content right">
                <h3>6. Kalite Kontrol ve Paketleme</h3>
                <p>Son aşamada, ürettiğimiz kılıfları detaylı kalite kontrol süreçlerinden geçiriyoruz. Çizik, deformasyon veya baskı hatası gibi sorunları tespit ediyor ve gereken durumlarda ürünleri eliyoruz. Kalite onayını alan kılıflarımızı özenle paketliyor ve satışa hazır hale getiriyoruz.</p>
                <img src="/images/process/packaging.jpg" alt="Paketleme" className="timeline-image" />
              </div>
            </motion.div>
          </div>
        </Container>
      </section>

      {/* Kalite Taahhüdü */}
      <section className="quality-pledge py-5 bg-light">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
              >
                <h2 className="mb-4">Kalite Taahhüdümüz</h2>
                <p className="lead">
                  Her bir kılıf, 10 yıllık tecrübemiz ve ustalığımızla üretilmektedir. 
                  Kullandığımız premium malzemeler ve el işçiliği ile en yüksek kaliteyi 
                  garanti ediyoruz.
                </p>
                <div className="mt-4">
                  <span className="quality-badge">2 Yıl Garanti</span>
                  <span className="quality-badge">%100 El Yapımı</span>
                  <span className="quality-badge">Premium Malzeme</span>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Process; 